import { useState, useEffect, useRef } from "react";
import Config from "../Config"
import { getJobData } from "../utils/Api"

import { useAuth } from '../utils/AuthContext';

function useJobMonitor(documentID, enabled) {
    const [status, setStatus] = useState({});
    const [isDone, setIsDone] = useState(false);
    const [error, setError] = useState(null);
    const ws = useRef(null);
    const { token } = useAuth();

    useEffect(() => {
        if (!enabled || !documentID || !token) {
            if (ws.current) {
                console.log("Closing WebSocket due to disabled or missing parameters")
                ws.current.close();
                ws.current = null;
            }
            return;
        }

        setStatus("Connecting...");
        setError(null);
        setIsDone(false);
        setStatus({});

        const scheme = Config.DISABLE_SSL ? "ws" : "wss";
        const socketResource = `${scheme}://${Config.HOSTNAME}/api/document/${documentID}`;

        console.log(`Attempting to connect to WebSocket at ${socketResource}`);
        ws.current = new WebSocket(`${socketResource}?token=${token}`);
        const socket = ws.current;

        socket.onopen = () => {
            console.log("WebSocket connected");
            setStatus("Waiting for Status Update");
            setError(null);
        };

        socket.onmessage = async (event) => {
            try {
                const message = JSON.parse(event.data);
                console.log("Websocket Message:", message);

                console.log(message);
                if (message.status) {
                    setStatus(prevStatus => ({
                        ...prevStatus,
                        ...message.status
                    }));
                } else {
                    console.warn("Received WebSocket message without 'status' field:", message);
                    setStatus("Received Update");
                }

            } catch (error) {
                console.error("Failed to parse WebSocket message, closing WebSocket:", event.data, error);
                setError("Failed to parse server message");

                socket.close();
                ws.current = null;
            }
        };

        socket.onerror = (event) => {
            console.error("WebSocket error:", event);
            setError("WebSocket Error")
            ws.current = null;
        };

        socket.onclose = (event) => {
            if (ws.current && !isDone && !error) {
                console.log(`WebSocket closed unexpectedly: Code=${event.code}, Reason=${event.reason}`);
                setError("WebSocket Closed Unexpectedly");
            } else {
                console.log(`WebSocket Closed: Code=${event.code}`);
            }
            ws.current = null;
        }

        return () => {
            if (ws.current) {
                console.log("Closing WebSocket connection (cleanup).");
                ws.current.close();
                ws.current = null;
            }
            setStatus(null);
            setIsDone(false);
        }
    }, [documentID, token, enabled]);

    return { status, isDone, error };
}

export default useJobMonitor;